import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class DomesticHotWaterTemperatureSetpoint implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 01 8C F4 01',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.DomesticHotWaterTemperatureSetpoint,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'DomesticHotWaterTemperatureSetpoint',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_Value',
              unit: '°C',
              translationid: 'TI_Value',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              name: 'PA_Value',
              value: '50.0',
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 8C',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.DomesticHotWaterTemperatureSetpoint,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '396',
          value: 'DomesticHotWaterTemperatureSetpoint',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'METADATA',
              longname: 'MetaDataValue',
              byteposition: '0',
              dopname: 'Substructure VDD MetaData DomesticHotWaterTemperatureSetpoint',
              precision: '',
              byteLength: '-1',
              type: 'eSTRUCTURE',
              shortname: 'PA_MetaDataValue',
              constraints: '',
              structure: [
                {
                  semantic: 'LOWLOWLEVEL',
                  longname: 'LowLow',
                  byteposition: '0',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_LowLow',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Value/PA_MetaDataValue/PA_LowLow',
                  unit: '°C',
                  translationid: 'TI_LowLow',
                  bitposition: '0',
                  name: 'PA_LowLow',
                  value: '10.0',
                },
                {
                  semantic: 'LOWLEVEL',
                  longname: 'Low',
                  byteposition: '2',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Low',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Value/PA_MetaDataValue/PA_Low',
                  unit: '°C',
                  translationid: 'TI_Low',
                  bitposition: '0',
                  name: 'PA_Low',
                  value: '15.0',
                },
                {
                  semantic: 'DEFLEVEL',
                  longname: 'Default',
                  byteposition: '4',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Defau',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Value/PA_MetaDataValue/PA_Defau',
                  unit: '°C',
                  translationid: 'TI_Default',
                  bitposition: '0',
                  name: 'PA_Defau',
                  value: '50.0',
                },
                {
                  semantic: 'HIGHLEVEL',
                  longname: 'High',
                  byteposition: '6',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_High',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Value/PA_MetaDataValue/PA_High',
                  unit: '°C',
                  translationid: 'TI_High',
                  bitposition: '0',
                  name: 'PA_High',
                  value: '55.0',
                },
                {
                  semantic: 'HIGHHIGHLEVEL',
                  longname: 'HighHigh',
                  byteposition: '8',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_HighHigh',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Value/PA_MetaDataValue/PA_HighHigh',
                  unit: '°C',
                  translationid: 'TI_HighHigh',
                  bitposition: '0',
                  name: 'PA_HighHigh',
                  value: '65.0',
                },
              ],
              path: 'PA_Value/PA_MetaDataValue',
              unit: '',
              translationid: 'TI_MetaDataValue',
              bitposition: '0',
              name: 'PA_MetaDataValue',
              value: '5',
            },
            {
              semantic: 'VDDLINK',
              longname: 'VddMetaDataLink',
              byteposition: '10',
              dopname: '0 to 254 Byte EOF-PDU Identical UTF8 Terminated Null',
              precision: '',
              byteLength: '-1',
              type: 'eA_UNICODE2STRING',
              shortname: 'PA_VddMetaDataLink',
              constraints: '[0:254]',
              path: 'PA_Value/PA_VddMetaDataLink',
              unit: '',
              translationid: 'TI_VddMetaDataLink',
              bitposition: '0',
              name: 'PA_VddMetaDataLink',
              value: 'DomesticHotWaterSetpointMetaData',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.DomesticHotWaterTemperatureSetpoint,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '396',
              value: 'DomesticHotWaterTemperatureSetpoint',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'VALUE',
                  longname: 'Value',
                  byteposition: '0',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Value',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Struc/PA_Value',
                  unit: '°C',
                  translationid: 'TI_Value',
                  bitposition: '0',
                  name: 'PA_Value',
                  value: '0.0',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
